if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        // Exclude the disabled placeholder <option> (it has no optionValueId).
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'))
          .map(({ dataset }) => dataset.optionValueId)
          .filter(Boolean);
      }

      // Every option group rendered by product-variant-picker (a <fieldset> for
      // button/swatch/color pickers, a <select> for dropdowns).
      get optionGroups() {
        return Array.from(this.querySelectorAll('fieldset, select'));
      }

      // True once the customer has chosen a value in every option group.
      get allOptionsSelected() {
        return this.optionGroups.length > 0 && this.selectedOptionValues.length >= this.optionGroups.length;
      }

      // Option groups that still have no chosen value.
      get unselectedGroups() {
        return this.optionGroups.filter((group) => {
          if (group.tagName === 'SELECT') {
            const selected = group.selectedOptions[0];
            return !selected || selected.hasAttribute('data-placeholder');
          }
          return !group.querySelector('input:checked');
        });
      }

      // Which button label to show while options are still being chosen:
      // "selectSize" when the only remaining group is the size option,
      // otherwise the generic "selectOptions".
      get selectionPromptKey() {
        const remaining = this.unselectedGroups;
        if (remaining.length === 1 && remaining[0].closest('[data-is-size-option]')) {
          return 'selectSize';
        }
        return 'selectOptions';
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
